import { wsCall, requestHelper, setSuccess } from "../../../app/coreSlice";
import { assetAssetReservationCounts, assetList } from "../../asset/assetSlice";

const reservationNewReservationCloseBoCall = async (
  { setSelectedTrip, reservationOngoingList },
  dispatch,
  state,
  { reservationCode, carToken },
  oldActions
) => {
  const selectedLocation = state?.getIn(["carclub2"])?.defaultLocation;
  let rh = requestHelper(dispatch, "RESERVATION/NEW_RESERVATION_CLOSE_BO");
  try {
    const result = await wsCall({
      type: "RESERVATION",
      subType: "NEW_RESERVATION_CLOSE_BO",
      locationId: selectedLocation?.id,
      message: {
        reservationCode,
        carToken,
        forceClose: true,
      },
    });

    if (!result.error) {
      dispatch(setSuccess("Reservation closed successfully!"));
      dispatch(setSelectedTrip());
      oldActions.remove({ code: result?.reservation?.code });
      setTimeout(() => {
        // this should be update using notifications
        dispatch(assetList({}));
        dispatch(assetAssetReservationCounts());
        dispatch(reservationOngoingList(null, true));
      }, 300);
      // refresh reservations
    } else {
      rh.error(result?.description || "Error closing reservation.");
    }
  } catch (_ex) {
    rh.error("Error closing reservation.");
  }
  rh.close();
};

export default reservationNewReservationCloseBoCall;
